import { isValidElement } from 'react';

const getNodeText = (node) => {
    /* istanbul ignore else */
    if (['string', 'number'].includes(typeof node))
        return node;
    /* istanbul ignore else */
    if (node instanceof Array)
        return node.map(getNodeText).join('');
    /* istanbul ignore else */
    if (typeof node === 'object' && isValidElement(node)) {
        if (node.type &&
            node.type.displayName &&
            node.type.displayName.includes('Tooltip'))
            return '';
        if (!node.props.children && typeof node.type === 'function')
            getNodeText(node.type(node.props).props
                .children);
        return getNodeText(node.props.children);
    }
};

export { getNodeText as default };
